import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  FormFeedback,
  Label,
  Input,
  FormText,
} from "reactstrap"
import Select from "react-select"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Redux
import { Link, useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  addAwardNomination,
  getAwardDetails,
} from "../../../redux/actions/awards"
import ImageCropModal from "components/ImageCropModal"
import { ADD_AWARD_NOMINATION_RESET } from "../../../redux/types/awards"
import { getUserDetailsRequest } from "../../../redux/actions/auth"
import ProfileMenu from "components/CommonForBoth/TopbarDropdown/ProfileMenu"
import InfoPopup from "components/InfoPopup"
import portraitImage from "../../../assets/images/portrait-img.png"
import ErrorPopup from "components/ErrorPopup"
import Loader from "components/Common/Loader"
import PageLoader from "components/Common/PageLoader"
import ConfirmPopup from "components/ConfirmPopup"

const stateOptions = [
  {
    options: [
      {
        label: "Andaman and Nicobar Islands",
        value: 4023,
      },
      {
        label: "Andhra Pradesh",
        value: 4017,
      },
      {
        label: "Arunachal Pradesh",
        value: 4024,
      },
      {
        label: "Assam",
        value: 4027,
      },
      {
        label: "Bihar",
        value: 4037,
      },
      {
        label: "Chandigarh",
        value: 4031,
      },
      {
        label: "Chhattisgarh",
        value: 4040,
      },
      {
        label: "Dadra and Nagar Haveli and Daman and Diu",
        value: 4033,
      },
      {
        label: "Delhi",
        value: 4021,
      },
      {
        label: "Goa",
        value: 4009,
      },
      {
        label: "Gujarat",
        value: 4030,
      },
      {
        label: "Haryana",
        value: 4007,
      },
      {
        label: "Himachal Pradesh",
        value: 4020,
      },
      {
        label: "Jammu and Kashmir",
        value: 4029,
      },
      {
        label: "Jharkhand",
        value: 4025,
      },
      {
        label: "Karnataka",
        value: 4026,
      },
      {
        label: "Kerala",
        value: 4028,
      },
      {
        label: "Ladakh",
        value: 4852,
      },
      {
        label: "Lakshadweep",
        value: 4019,
      },
      {
        label: "Madhya Pradesh",
        value: 4039,
      },
      {
        label: "Maharashtra",
        value: 4008,
      },
      {
        label: "Manipur",
        value: 4010,
      },
      {
        label: "Meghalaya",
        value: 4006,
      },
      {
        label: "Mizoram",
        value: 4036,
      },
      {
        label: "Nagaland",
        value: 4018,
      },
      {
        label: "Odisha",
        value: 4013,
      },
      {
        label: "Puducherry",
        value: 4011,
      },
      {
        label: "Punjab",
        value: 4015,
      },
      {
        label: "Rajasthan",
        value: 4014,
      },
      {
        label: "Sikkim",
        value: 4034,
      },
      {
        label: "Tamil Nadu",
        value: 4035,
      },
      {
        label: "Telangana",
        value: 4012,
      },
      {
        label: "Tripura",
        value: 4038,
      },
      {
        label: "Uttar Pradesh",
        value: 4022,
      },
      {
        label: "Uttarakhand",
        value: 4016,
      },
      {
        label: "West Bengal",
        value: 4853,
      },
    ],
  },
]

const getWordCount = (text = "") => {
  return text.trim().split(/\s+/).filter(Boolean).length
}

const AwardsForm = props => {
  const navigate = useNavigate()
  const { url } = useParams()
  const dispatch = useDispatch()

  const [profilePreview, setProfilePreview] = useState(null)
  const [profileFile, setProfileFile] = useState(null)
  const [pvsOptions, setPvsOptions] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [categoryOptions, setCategoryOptions] = useState([])
  const [previewOpen, setPreviewOpen] = useState(false)
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)

  const infoPopMessage = (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={portraitImage}
          alt="Portrait"
          style={{ maxWidth: "30%", height: "auto", objectFit: "contain" }}
        />
      </div>
      <div>
        <h5 className="mb-3">
          Please read the instructions carefully before you upload your
          documents
        </h5>
        <ul className="mb-0 ps-3">
          <li className="mb-3">Your Passport size photo</li>
          <li className="mb-3">You should be alone in the photo</li>
          <li className="mb-3">
            Image should be clear and well-lit (no blur or shadows)
          </li>
          <li className="mb-3">Background should be plain and not cluttered</li>
          <li className="mb-3">Face should be clearly visible and centered</li>
          <li className="mb-3">No sunglasses or hats that obscure the face</li>
          <li className="mb-3">Ensure good lighting without harsh shadows</li>
        </ul>
      </div>
    </div>
  )

  const togglePreview = () => setPreviewOpen(!previewOpen)

  const openPreview = () => {
    setPreviewOpen(true)
  }

  const awardDetails = useSelector(state => state.awards.awardDetails)
  const user = useSelector(state => state.auth.user)
  const awards = useSelector(state => state.auth.awards)
  const pvs_cards = useSelector(state => state.auth.pvs_cards)
  const token = useSelector(state => state.auth.token)
  const addAwardNominationScreen = useSelector(
    state => state.screens.awards.addAwardNomination
  )

  useEffect(() => {
    if (token === null) {
      navigate("/login", { replace: true })
    } else {
      dispatch(getUserDetailsRequest())
      dispatch(getAwardDetails(url))
    }
  }, [])

  useEffect(() => {
    if (
      awards &&
      awards.length > 0 &&
      (awards[0].status === "s1_paid" ||
        awards[0].status === "shortlisted" ||
        awards[0].status === "s2_paid")
    ) {
      // User already has awards, redirect to billing
      navigate("/nominee-booking-confirm", { replace: true })
    } else if (awards && awards.length > 0 && awards[0].status === "pending") {
      navigate("/awards-billing-details", { replace: true })
    }
  }, [awards])

  useEffect(() => {
    if (addAwardNominationScreen.success) {
      toast.success(addAwardNominationScreen.message)
      dispatch({ type: ADD_AWARD_NOMINATION_RESET })
      navigate("/awards-billing-details", {})
    }
    if (addAwardNominationScreen.error) {
      toast.error(addAwardNominationScreen.error)
      dispatch({ type: ADD_AWARD_NOMINATION_RESET })
    }
  }, [addAwardNominationScreen])

  useEffect(() => {
    if (awardDetails && awardDetails.category_options.length > 0) {
      let tempCategoryOption = []
      awardDetails.category_options.map(option => {
        tempCategoryOption.push({
          label: option.category,
          value: option.enc_cat_awd_id,
        })
      })
      setCategoryOptions(tempCategoryOption)
      // if(awards.length > 0) {

      // }
    }
  }, [awardDetails])

  useEffect(() => {
    if (awards && awards.length > 0) {
      let formValues = {
        award_user_photo: null,
        category: null,
        full_name: awards[0].full_name || "",
        email_id: awards[0].email_id || "",
        contact_no: awards[0].contact_no || "",
        wa_mobile_no: awards[0].wa_mobile_no || "",
        city: awards[0].city || "Pune",
        state:
          stateOptions[0].options.find(
            value => value.label === awards[0].state
          ) || stateOptions[0].options[20],
        age: null,
        food_preference: null,
        pvs_card_number: null,
        establishment_year: awards[0].establishment_year || "",
        company_type: null,
        business_name: awards[0].business_name || "",
        business_nature: null,
        business_description: awards[0].business_description || "",
        nomination_reason: awards[0].nomination_reason || "",
        website_link: awards[0].website_link || "",
        insta_link: awards[0].insta_link || "",
        fb_link: awards[0].fb_link || "",
        linkedin_link: awards[0].linkedin_link || "",
        youtube_link: awards[0].youtube_link || "",
        tnc: false,
      }
      if (awardDetails) {
        // formValues.category = awardDetails.category_options.find(
        //   option => option.enc_cat_awd_id === awards[0].category
        // )?.category

        awardDetails.category_options.find(option => {
          if (option.awd_cat_id === awards[0].awd_cat_id) {
            formValues.category = {
              label: option.category,
              value: option.enc_cat_awd_id,
            }
          }
        })
        formValues.age = awardDetails.age_group_options.find(
          option => option.value === awards[0].age
        )
        formValues.food_preference = awardDetails.food_preference_options.find(
          option => option.value === awards[0].food_preference
        )
        formValues.company_type = awardDetails.company_type_options.find(
          option => option.value === awards[0].company_type
        )
        formValues.business_nature = awardDetails.business_nature_options.find(
          option => option.value === awards[0].business_nature
        )
      }

      formik.setValues(formValues)
      if (awards[0].user_photo_url) {
        convertUrlToBlob(
          "award_user_photo",
          "awards_profile_pic.jpg",
          awards[0].user_photo_url
        )
      }
    } else {
      formik.setValues({
        award_user_photo: null,
        category: null,
        full_name: user ? `${user.first_name} ${user.last_name}` : "",
        email_id: user ? user.email_id : "",
        contact_no: user ? user.contact_no : "",
        wa_mobile_no: user ? user.mobile_no : "",
        city: user && user.city ? user.city : "Pune",
        state:
          user && user.state
            ? stateOptions[0].options.find(value => value.label === user.state)
            : stateOptions[0].options[20],
        age: null,
        food_preference: null,
        pvs_card_number: null,
        establishment_year: "",
        company_type: null,
        business_name: user ? user.company_name : "",
        business_nature: null,
        business_description: "",
        nomination_reason: "",
        website_link: user ? user.website_link : "",
        insta_link: user ? user.instagram_link : "",
        fb_link: user ? user.facebook_link : "",
        linkedin_link: user ? user.linkedin_link : "",
        youtube_link: "",
        tnc: false,
      })
    }
  }, [awards, user, awardDetails])

  useEffect(() => {
    if (profileFile) {
      setIsOpen(true)
    }
  }, [profileFile])

  useEffect(() => {
    if (pvs_cards && pvs_cards.length > 0) {
      let tempOptions = []
      tempOptions = pvs_cards.map(card => ({
        label: card.token_code,
        value: card.token_code,
      }))
      setPvsOptions(tempOptions)
      if (tempOptions.length === 1)
        formik.setFieldValue("pvs_card_number", tempOptions[0])
    } else {
      setIsConfirmOpen(true)
    }
  }, [pvs_cards])

  function onSelectFile(event) {
    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }

    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader()
      reader.onload = e => {
        setProfileFile(e.target.result)
      }
      reader.readAsDataURL(event.target.files[0])
    }
  }

  function saveImage(blob, blobUrl) {
    const file = new File([blob], "my_profile_pic.jpg", {
      type: blob.type,
      lastModified: Date.now(),
    })
    formik.setFieldValue("award_user_photo", {
      name: file.name,
      file: file,
      url: blobUrl,
    })
  }

  const formik = useFormik({
    initialValues: {
      award_user_photo: null,
      category: null,
      full_name: "",
      email_id: "",
      contact_no: "",
      wa_mobile_no: "",
      age: null,
      food_preference: null,
      city: "",
      state: null,
      pvs_card_number: null,
      establishment_year: "",
      company_type: null,
      business_name: "",
      business_nature: null,
      business_description: "",
      nomination_reason: "",
      website_link: "",
      insta_link: "",
      fb_link: "",
      linkedin_link: "",
      youtube_link: "",
      tnc: false,
    },
    validationSchema: Yup.object({
      award_user_photo: Yup.mixed().required("Profile Photo is required"),
      category: Yup.object().required("Category is required"),
      full_name: Yup.string().required("Full Name is required"),
      email_id: Yup.string()
        .email("Invalid email")
        .required("Email is required"),
      contact_no: Yup.string().required("Contact Number is required"),
      wa_mobile_no: Yup.string().required("WhatsApp Number is required"),
      state: Yup.object().required("State is required"),
      city: Yup.string().required("City is required"),
      age: Yup.object().required("Age Group is required"),
      food_preference: Yup.object().required("Food Preference is required"),
      establishment_year: Yup.string().required(
        "Establishment Year is required"
      ),
      company_type: Yup.object().required("Company Type is required"),
      business_name: Yup.string().required("Business Name is required"),
      business_nature: Yup.object().required("Business Nature is required"),
      business_description: Yup.string()
        .required("Business Description is required")
        .test(
          "word-count",
          "Description must be between 100 and 150 words",
          value => {
            const count = getWordCount(value)
            return count >= 100 && count <= 150
          }
        ),
      // .min(100, "Description must be at least 100 words")
      // .max(150, "Description must be at most 150 words")
      // .required("Business Description is required"),

      nomination_reason: Yup.string()
        .required("Nomination Reason is required")
        .test(
          "word-count",
          "Reason must be between 200 and 300 words",
          value => {
            const count = getWordCount(value)
            return count >= 200 && count <= 300
          }
        ),
      // .min(200, "Reason must be at least 200 characters")
      // .max(300, "Reason must be at most 300 characters")
      // .required("Nomination Reason is required"),

      website_link: Yup.string().url("Invalid Website URL"),
      insta_link: Yup.string().url("Invalid Instagram URL"),
      fb_link: Yup.string().url("Invalid Facebook URL"),
      linkedin_link: Yup.string().url("Invalid LinkedIn URL"),
      youtube_link: Yup.string().url("Invalid YouTube URL"),
      tnc: Yup.boolean().oneOf(
        [true],
        "You must accept the terms and conditions"
      ),
    }),
    onSubmit: values => {
      const formData = new FormData()
      formData.append("enc_award_id", awardDetails.enc_award_id)
      formData.append("enc_awd_cat_id", values.category.value)
      formData.append("business_name", values.business_name)
      formData.append("user_photo", values.award_user_photo.file)
      formData.append("full_name", values.full_name)
      formData.append("email_id", values.email_id)
      formData.append("contact_no", values.contact_no)
      formData.append("wa_mobile_no", values.wa_mobile_no)
      formData.append("state", values.state.label)
      formData.append("city", values.city)
      formData.append("age", values.age.value)
      formData.append("food_preference", values.food_preference.value)
      formData.append(
        "pvs_card_number",
        values.pvs_card_number && values.pvs_card_number.value
          ? values.pvs_card_number.value
          : ""
      )
      formData.append("establishment_year", values.establishment_year)
      formData.append("company_type", values.company_type.value)
      formData.append("business_nature", values.business_nature.value)
      formData.append("business_description", values.business_description)
      formData.append("nomination_reason", values.nomination_reason)
      formData.append("website_link", values.website_link || "")
      formData.append("insta_link", values.insta_link || "")
      formData.append("fb_link", values.fb_link || "")
      formData.append("linkedin_link", values.linkedin_link || "")
      formData.append("youtube_link", values.youtube_link || "")
      formData.append("tnc", values.tnc)

      if (awards.length > 0) {
        formData.append(
          "enc_award_nomination_id",
          awards[0].enc_award_nomination_id
        )
      }

      dispatch(addAwardNomination(formData))
    },
  })

  // Word Count and Limit Words Functionality @Daanish @Kajal
  const wordCount = getWordCount(formik.values.business_description)
  const wordCountNom = getWordCount(formik.values.nomination_reason)
  const handleWordLimitChange = (field, maxWords) => e => {
    const value = e.target.value
    const words = value.trim().split(/\s+/).filter(Boolean)

    if (words.length <= maxWords) {
      formik.setFieldValue(field, value)
    } else {
      const trimmedValue = words.slice(0, maxWords).join(" ")
      formik.setFieldValue(field, trimmedValue)
    }
  }
  useEffect(() => {
    if (formik.isSubmitting && formik.errors) {
      let message = (
        <div>
          {/* <h5 className="mb-3">
          Please read the instructions carefully before you upload your
          documents
        </h5> */}
          <ul className="mb-0 ps-3">
            {Object.keys(formik.errors).map(key => (
              <li key={key} className="mb-3">
                {formik.errors[key]}
              </li>
            ))}
          </ul>
        </div>
      )

      setIsErrorMessage(message)
      setIsErrorOpen(true)
    }
  }, [formik])

  async function convertUrlToBlob(fieldName, filename, url) {
    // Fetch the image data from the URL
    const response = await fetch(url)

    // Get the response data as a Blob
    const blob = await response.blob()

    // Determine the file type (MIME type) from the blob
    // Fallback to a default type if the response doesn't provide one
    const type = blob.type || "image/jpeg" //

    // Create a new File object using the Blob, filename, and type
    const file = new File([blob], filename, { type })

    formik.setFieldValue(fieldName, {
      file,
      name: file.name,
      type: file.type,
      url: URL.createObjectURL(file),
    })
  }

  document.title = "Awards | 2025 | PULA"
  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="award-form-wrapper newaward-maincontainer pt-4">
          <Row className="newaward-row">
            <Col xs={12} lg={5} xl={5}>
              <div className="content-boxnew mb-4">
                <h2 className="title mb-2 h2">
                  <span className="main-highlight">
                    PULA Women Entrepreneurs Award Ceremony
                  </span>
                </h2>
                <div className="mt-4">
                  <p>
                    <span className="highlighted">Date</span> -{" "}
                    <strong>
                      {awardDetails && awardDetails.award_date
                        ? awardDetails.award_date
                        : "TBD"}
                    </strong>
                  </p>
                  <p>
                    <span className="highlighted">Time</span> -{" "}
                    <strong>
                      {awardDetails && awardDetails.time_slot
                        ? awardDetails.time_slot
                        : "TBD"}
                    </strong>
                  </p>
                  <p>
                    <span className="highlighted">Venue</span> -{" "}
                    <strong>
                      {awardDetails && awardDetails.address
                        ? awardDetails.address
                        : "TBD"}
                    </strong>
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} lg={7} xl={7}>
              <Card className="overflow-hidden">
                <CardBody>
                  {/* Nomination Form */}
                  <div className="form-section">
                    <div>
                      <Form
                        className="mt-4"
                        onSubmit={e => {
                          e.preventDefault()
                          formik.handleSubmit()
                          return false
                        }}
                        action="#"
                      >
                        <div className="nominee-form-wrapper d-flex flex-column">
                          {/* PROFILE UPLOAD */}
                          <div className="profile-upload-section">
                            <div className="profile-upload-wrapper text-center mb-4">
                              <div className="profile-avatar">
                                {formik.values.award_user_photo ? (
                                  <img
                                    src={formik.values.award_user_photo.url}
                                    alt="Nominee profile"
                                    className="avatar-img"
                                  />
                                ) : (
                                  <div className="avatar-placeholder">
                                    <i className="mdi mdi-account-outline"></i>
                                  </div>
                                )}

                                {/* Menu Button */}
                                {formik.values.award_user_photo && (
                                  <div className="avatar-menu">
                                    <button type="button" className="menu-btn">
                                      <i className="mdi mdi-dots-vertical"></i>
                                    </button>

                                    <div className="menu-dropdown">
                                      <label htmlFor="profileUpload">
                                        <i className="mdi mdi-pencil"></i>{" "}
                                        Change Photo
                                      </label>
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setProfileFile(null)
                                          formik.setFieldValue(
                                            "award_user_photo",
                                            null
                                          )
                                        }}
                                      >
                                        <i className="mdi mdi-delete"></i>{" "}
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                )}

                                {/* Hidden Input */}
                                <input
                                  type="file"
                                  id="profileUpload"
                                  accept="image/*"
                                  hidden
                                  onChange={onSelectFile}
                                />
                              </div>

                              {/* Upload Button */}
                              {!formik.values.award_user_photo && (
                                <label
                                  htmlFor="profileUpload"
                                  className="upload-btn"
                                >
                                  <i className="mdi mdi-camera"></i>
                                  Upload Photo
                                </label>
                              )}

                              <small className="text-muted click-here-text">
                                Please{" "}
                                <span
                                  className="text-primary strong"
                                  onClick={() => openPreview()}
                                >
                                  click here
                                </span>{" "}
                                to read the instructions before uploading your
                                photo.
                              </small>

                              {formik.touched.award_user_photo &&
                                formik.errors.award_user_photo && (
                                  <FormFeedback
                                    className="d-block"
                                    type="invalid"
                                  >
                                    {formik.errors.award_user_photo}
                                  </FormFeedback>
                                )}
                            </div>
                          </div>

                          {/* FORM CONTENT */}
                          <div className="form-content">
                            <h2 className="heading-tags h2">Nomination Form</h2>
                            {/* Award Category */}
                            <h3 className="nom-title">Award Category</h3>
                            <div className="row">
                              <div className="mb-4 col-md-12">
                                <Label
                                  className="form-label"
                                  htmlFor="category"
                                >
                                  Select your preferred category{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>

                                <Select
                                  id="business_nature"
                                  name="business_nature"
                                  options={categoryOptions}
                                  value={formik.values.category}
                                  onChange={val => {
                                    formik.setFieldValue("category", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                />
                                {formik.touched.category &&
                                  formik.errors.category && (
                                    <FormFeedback
                                      className="d-block"
                                      type="invalid"
                                    >
                                      {formik.errors.category}
                                    </FormFeedback>
                                  )}
                              </div>
                            </div>

                            {/* Nominee Details */}
                            <div className="separate"></div>
                            <h3 className="nom-title">Nominee Details</h3>
                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="full_name"
                                >
                                  Nominee Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="full_name"
                                  className="form-control"
                                  placeholder="Enter Full Nominee Name"
                                  type="text"
                                  id="full_name"
                                  onChange={formik.handleChange}
                                  value={formik.values.full_name || ""}
                                  invalid={
                                    formik.touched.full_name &&
                                    formik.errors.full_name
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.full_name &&
                                formik.errors.full_name ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.full_name}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="email_id"
                                >
                                  Email <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="email_id"
                                  className="form-control"
                                  placeholder="Enter Email"
                                  type="email_id"
                                  id="email_id"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.email_id || ""}
                                  invalid={
                                    formik.touched.email_id &&
                                    formik.errors.email_id
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.email_id &&
                                formik.errors.email_id ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.email_id}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="wa_mobile_no"
                                >
                                  Whatsapp Number{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="wa_mobile_no"
                                  className="form-control"
                                  placeholder="Enter Whatsapp Number"
                                  type="tel"
                                  id="wa_mobile_no"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.wa_mobile_no || ""}
                                  invalid={
                                    formik.touched.wa_mobile_no &&
                                    formik.errors.wa_mobile_no
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.wa_mobile_no &&
                                formik.errors.wa_mobile_no ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.wa_mobile_no}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="contact_no"
                                >
                                  Contact Number{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="contact_no"
                                  className="form-control"
                                  placeholder="Enter Contact Number"
                                  type="tel"
                                  id="contact_no"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.contact_no || ""}
                                  invalid={
                                    formik.touched.contact_no &&
                                    formik.errors.contact_no
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.contact_no &&
                                formik.errors.contact_no ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.contact_no}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="insta_link"
                                >
                                  Age <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Select
                                  id="age"
                                  name="age"
                                  options={
                                    awardDetails
                                      ? awardDetails.age_group_options
                                      : []
                                  }
                                  value={formik.values.age}
                                  onChange={val => {
                                    formik.setFieldValue("age", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                  invalid={
                                    formik.touched.age && formik.errors.age
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.age && formik.errors.age && (
                                  <FormFeedback
                                    className="d-block"
                                    type="invalid"
                                  >
                                    {formik.errors.age}
                                  </FormFeedback>
                                )}
                              </div>
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="insta_link"
                                >
                                  Food Preference{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Select
                                  id="food_preference"
                                  name="food_preference"
                                  options={
                                    awardDetails
                                      ? awardDetails.food_preference_options
                                      : []
                                  }
                                  value={formik.values.food_preference}
                                  onChange={val => {
                                    formik.setFieldValue("food_preference", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                  invalid={
                                    formik.touched.food_preference &&
                                    formik.errors.food_preference
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.food_preference &&
                                  formik.errors.food_preference && (
                                    <FormFeedback
                                      className="d-block"
                                      type="invalid"
                                    >
                                      {formik.errors.food_preference}
                                    </FormFeedback>
                                  )}
                              </div>
                            </div>

                            {/* Business / Organisation Details */}
                            <div className="separate"></div>
                            <h3 className="nom-title">
                              Business / Organisation Details
                            </h3>
                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="pvs_card_number"
                                >
                                  PVS Card Number
                                </Label>
                                <Select
                                  id="pvs_card_number"
                                  name="pvs_card_number"
                                  options={pvsOptions}
                                  value={formik.values.pvs_card_number}
                                  onChange={val => {
                                    formik.setFieldValue("pvs_card_number", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                />
                              </div>
                              <div className="col-12 col-sm-6 mb-3">
                                <Label
                                  className="form-label"
                                  htmlFor="business_name"
                                >
                                  Business Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="business_name"
                                  className="form-control"
                                  placeholder="Enter Business Name"
                                  type="text"
                                  id="business_name"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.business_name || ""}
                                  invalid={
                                    formik.touched.business_name &&
                                    formik.errors.business_name
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.business_name &&
                                formik.errors.business_name ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.business_name}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 col-sm-6 mb-4">
                                <Label className="form-label" htmlFor="state">
                                  State <span style={{ color: "red" }}>*</span>
                                </Label>

                                <Select
                                  id="state"
                                  name="state"
                                  options={stateOptions}
                                  value={formik.values.state}
                                  onChange={val => {
                                    formik.setFieldValue("state", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                />
                                {formik.touched.state &&
                                  formik.errors.state && (
                                    <FormFeedback
                                      className="d-block"
                                      type="invalid"
                                    >
                                      {formik.errors.state}
                                    </FormFeedback>
                                  )}
                              </div>
                              <div className="col-12 col-sm-6 mb-4">
                                <Label
                                  className="form-label"
                                  htmlFor="wa_mobile_no"
                                >
                                  City <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="city"
                                  className="form-control"
                                  placeholder="Enter City"
                                  type="tel"
                                  id="city"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.city || ""}
                                  invalid={
                                    formik.touched.city && formik.errors.city
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.city && formik.errors.city ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.city}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="row">
                              <div className="mb-4 col-12 col-sm-6 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="company_type"
                                >
                                  Select the Type of Company{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>

                                <Select
                                  id="company_type"
                                  name="company_type"
                                  options={
                                    awardDetails
                                      ? awardDetails.company_type_options
                                      : []
                                  }
                                  value={formik.values.company_type}
                                  onChange={val => {
                                    formik.setFieldValue("company_type", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                />
                                {formik.touched.company_type &&
                                  formik.errors.company_type && (
                                    <FormFeedback
                                      className="d-block"
                                      type="invalid"
                                    >
                                      {formik.errors.company_type}
                                    </FormFeedback>
                                  )}
                              </div>
                              <div className="col-12 col-sm-6 mb-4">
                                <Label
                                  className="form-label"
                                  htmlFor="wa_mobile_no"
                                >
                                  Year of Establishment{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>
                                <Input
                                  name="establishment_year"
                                  className="form-control"
                                  placeholder="Enter Year of Establishment"
                                  type="number"
                                  id="establishment_year"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.establishment_year || ""}
                                  invalid={
                                    formik.touched.establishment_year &&
                                    formik.errors.establishment_year
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.establishment_year &&
                                formik.errors.establishment_year ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.establishment_year}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-4 col-12">
                                <Label
                                  className="form-label"
                                  htmlFor="sub_category"
                                >
                                  Select the Nature of Business{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Label>

                                <Select
                                  id="business_nature"
                                  name="business_nature"
                                  options={
                                    awardDetails
                                      ? awardDetails.business_nature_options
                                      : []
                                  }
                                  value={formik.values.business_nature}
                                  onChange={val => {
                                    formik.setFieldValue("business_nature", val)
                                  }}
                                  classNamePrefix="select2-selection"
                                  className="customselect"
                                />
                                {formik.touched.business_nature &&
                                  formik.errors.business_nature && (
                                    <FormFeedback
                                      className="d-block"
                                      type="invalid"
                                    >
                                      {formik.errors.business_nature}
                                    </FormFeedback>
                                  )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 col-lg-12">
                                <div className="mb-4">
                                  <Label
                                    className="form-label"
                                    htmlFor="business_description"
                                  >
                                    Brief Description of Business (100-150
                                    words):{" "}
                                    <span style={{ color: "red" }}>*</span>
                                    <br />
                                    <i className="text-small">
                                      (You can speak about your business and
                                      it's growth in the last few years, Turn
                                      Over, Profitability, number of employees,
                                      No of Customers, Reviews, etc.)
                                    </i>
                                  </Label>

                                  <textarea
                                    name="business_description"
                                    id="business_description"
                                    className={`form-control ${
                                      formik.touched.business_description &&
                                      formik.errors.business_description
                                        ? "is-invalid"
                                        : ""
                                    } ${
                                      wordCount >= 100 && wordCount <= 150
                                        ? "textarea-complete"
                                        : ""
                                    }`}
                                    rows="3"
                                    disabled={wordCount >= 150}
                                    onChange={handleWordLimitChange(
                                      "business_description",
                                      150
                                    )}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.business_description}
                                  />
                                  <div className="d-flex flex-wrap flex-row justify-content-between align-items-center p-2">
                                    <span
                                      className={`form-text ${
                                        wordCount > 150
                                          ? "text-danger"
                                          : wordCount >= 100
                                          ? "text-success"
                                          : "text-muted"
                                      }`}
                                      style={{
                                        whiteSpace: "nowrap",
                                        marginRight: "0.5rem",
                                      }}
                                    >
                                      {`${wordCount} / 150 words`}
                                    </span>
                                    {formik.touched.business_description &&
                                      formik.errors.business_description && (
                                        <div className="invalid-feedback d-inline-block">
                                          {formik.errors.business_description}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-12 col-lg-12">
                                <div className="mb-4">
                                  <Label
                                    className="form-label"
                                    htmlFor="nomination_reason"
                                  >
                                    Reson for Nomination{" "}
                                    <span style={{ color: "red" }}>*</span>
                                    <br />
                                    <i className="text-small">
                                      (Explain why the nominee deserves this
                                      award. Include achievements, challenges
                                      overcome, innovation, growth, impact, or
                                      leadership qualities. 200-300 words)
                                    </i>
                                  </Label>

                                  <textarea
                                    name="nomination_reason"
                                    id="nomination_reason"
                                    className={`form-control ${
                                      formik.touched.nomination_reason &&
                                      formik.errors.nomination_reason
                                        ? "is-invalid"
                                        : ""
                                    } ${
                                      wordCountNom >= 200 && wordCountNom <= 300
                                        ? "textarea-complete"
                                        : ""
                                    }`}
                                    disabled={wordCountNom >= 300}
                                    rows="3"
                                    style={{ cursor: "text" }}
                                    onChange={handleWordLimitChange(
                                      "nomination_reason",
                                      300
                                    )}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.nomination_reason}
                                  />

                                  <div className="d-flex flex-wrap flex-row justify-content-between align-items-center p-2">
                                    <span
                                      className={`form-text ${
                                        wordCountNom > 300
                                          ? "text-danger"
                                          : wordCountNom >= 200
                                          ? "text-success"
                                          : "text-muted"
                                      }`}
                                      style={{
                                        whiteSpace: "nowrap",
                                        marginRight: "0.5rem",
                                      }}
                                    >
                                      {`${wordCountNom} / 300 words`}
                                    </span>
                                    {formik.touched.nomination_reason &&
                                      formik.errors.nomination_reason && (
                                        <div className="invalid-feedback d-inline-block">
                                          {formik.errors.nomination_reason}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="separate"></div>
                            <h3 className="nom-title">
                              Digital Presence (Please share links as
                              applicable)
                            </h3>
                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="full_name"
                                >
                                  🌐 Website
                                </Label>
                                <Input
                                  name="website_link"
                                  className="form-control"
                                  placeholder="Enter link here"
                                  type="text"
                                  id="website_link"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.website_link}
                                  invalid={
                                    formik.touched.website_link &&
                                    formik.errors.website_link
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.website_link &&
                                formik.errors.website_link ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.website_link}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="email_id"
                                >
                                  📸 Instagram
                                </Label>
                                <Input
                                  name="insta_link"
                                  className="form-control"
                                  placeholder="Enter link here"
                                  type="insta_link"
                                  id="insta_link"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.insta_link}
                                  invalid={
                                    formik.touched.insta_link &&
                                    formik.errors.insta_link
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.insta_link &&
                                formik.errors.insta_link ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.insta_link}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>

                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="full_name"
                                >
                                  📘 Facebook
                                </Label>
                                <Input
                                  name="fb_link"
                                  className="form-control"
                                  placeholder="Enter link here"
                                  type="text"
                                  id="fb_link"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.fb_link}
                                  invalid={
                                    formik.touched.fb_link &&
                                    formik.errors.fb_link
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.fb_link &&
                                formik.errors.fb_link ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.fb_link}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="email_id"
                                >
                                  💼 LinkedIn
                                </Label>
                                <Input
                                  name="linkedin_link"
                                  className="form-control"
                                  placeholder="Enter link here"
                                  type="linkedin_link"
                                  id="linkedin_link"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.linkedin_link}
                                  invalid={
                                    formik.touched.linkedin_link &&
                                    formik.errors.linkedin_link
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.linkedin_link &&
                                formik.errors.linkedin_link ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.linkedin_link}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>

                            <div className="row">
                              <div className="mb-4 col-md-6">
                                <Label
                                  className="form-label"
                                  htmlFor="full_name"
                                >
                                  ▶️ Youtube
                                </Label>
                                <Input
                                  name="youtube_link"
                                  className="form-control"
                                  placeholder="Enter link here"
                                  type="text"
                                  id="youtube_link"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.youtube_link}
                                  invalid={
                                    formik.touched.youtube_link &&
                                    formik.errors.youtube_link
                                      ? true
                                      : false
                                  }
                                />
                                {formik.touched.youtube_link &&
                                formik.errors.youtube_link ? (
                                  <FormFeedback type="invalid">
                                    {formik.errors.youtube_link}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </div>
                            <div className="my-3 form-check checkbox-verify">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={formik.values.tnc}
                                onChange={e =>
                                  formik.setFieldValue("tnc", e.target.checked)
                                }
                              />
                              <label className="form-check-label">
                                I hereby declare that the information provided
                                above is true and correct to the best of my
                                knowledge. I understand that the decision of the
                                jury will be final and binding.
                              </label>
                              {formik.touched.tnc && formik.errors.tnc && (
                                <FormFeedback
                                  className="d-block"
                                  type="invalid"
                                >
                                  {formik.errors.tnc}
                                </FormFeedback>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* Proceed To Pay Button */}
                        <div className="row">
                          <div className="col-12 text-center d-flex justify-content-center mt-2">
                            <button className="primary-button" type="submit">
                              Proceed To Pay
                            </button>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* <div className="mt-3 text-center">
            <p className="copyrights">
              © {new Date().getFullYear()} PULA. Crafted with{" "}
              <i className="mdi mdi-heart text-danger" /> by Autuskey
            </p>
          </div> */}
        </div>
        <ImageCropModal
          isOpen={isOpen}
          imgSrc={profileFile}
          saveImage={saveImage}
          toggle={() => setIsOpen(false)}
        />
        <InfoPopup
          size="md"
          isOpen={previewOpen}
          toggle={togglePreview}
          title="Upload Photo Instructions"
          message={infoPopMessage}
          // message="Please read this carefully. Add JPG and PNG file. Please make sure the image is clear and all details are visible. The file size should not exceed 2MB. The photo should be recent and taken against a plain background. Avoid using filters or editing the photo excessively. By uploading, you confirm that the photo is accurate and true representation."
        />
        <ErrorPopup
          isOpen={isErrorOpen}
          toggle={() => setIsErrorOpen(!isErrorOpen)}
          title="Fix following errors"
          message={isErrorMessage}
        />
        <PageLoader open={addAwardNominationScreen.loading} />
        <ConfirmPopup
          title="Unauthorized"
          isOpen={isConfirmOpen}
          message={
            "You need to be a PVS Member to proceed. Please become a PVS Member to proceed."
          }
          onConfirm={() => {
            navigate("/pvs-info", { replace: true })
          }}
          confirmText="Become a PVS Member"
          cancelText="I'll do it later"
          toggle={() => {
            setIsConfirmOpen(!isConfirmOpen)
            navigate("/home", { replace: true })
          }}
        />
      </div>
    </div>
  )
}
export default AwardsForm
